import { computed } from 'vue';
import { getRoute, getRouter, getPrevRoute } from '../router/helpers/initRouter.js';
import { getStore } from '../store/helpers/initStore.js';

function useRouteHeading() {
    const route = getRoute();
    const router = getRouter();
    const store = getStore();
    const heading = computed(() => {
        var _a, _b;
        const prevRoute = getPrevRoute().value;
        if (!route)
            return;
        return (_b = (_a = route.value.meta) === null || _a === void 0 ? void 0 : _a.heading) === null || _b === void 0 ? void 0 : _b.call(_a, {
            route: route.value,
            prevRoute,
            store,
            router,
        }).value;
    });
    return {
        heading,
    };
}

export { useRouteHeading };
